export const PERMISSION_SHOW = 'PERMISSION_SHOW'
export const PERMISSION_HIDE = 'PERMISSION_HIDE'

export const SET_ITEM = 'SET_ITEM'

export const GET_ITEM = 'GET_ITEM'
export const GET_ITEM_SUCCESS = 'GET_ITEM_SUCCESS'
export const GET_ITEM_FAILURE = 'GET_ITEM_FAILURE'

export const MYPERMISSION_REQUETS = 'MYPERMISSION_REQUETS'
export const MYPERMISSION_REQUETS_SUCCESS = 'MYPERMISSION_REQUETS_SUCCESS'
export const MYPERMISSION_REQUETS_FAILURE = 'MYPERMISSION_REQUETS_FAILURE'

export const GIVING_PERMISSION = 'GIVING_PERMISSION'
export const SET_IS_FETCHING_OBJECT_GROUPS = 'SET_IS_FETCHING_OBJECT_GROUPS'
export const UNSET_IS_FETCHING_OBJECT_GROUPS = 'UNSET_IS_FETCHING_OBJECT_GROUPS'
export const PERMISSION_HIDE_MODAL = 'PERMISSION_HIDE_MODAL'
export const PERMISSION_SHOW_MODAL = 'PERMISSION_SHOW_MODAL'
export const UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL = 'UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL'
export const SET_IS_FETCHING_OBJECT_GROUPS_MODAL = 'SET_IS_FETCHING_OBJECT_GROUPS_MODAL'

